import { render, staticRenderFns } from "./RbuAdminsList.vue?vue&type=template&id=88e90bba"
import script from "./RbuAdminsList.vue?vue&type=script&lang=js"
export * from "./RbuAdminsList.vue?vue&type=script&lang=js"
import style0 from "./RbuAdminsList.vue?vue&type=style&index=0&id=88e90bba&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports